import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getMyVehicles, getMyVehiclesKey } from '../api-client/search'
import { ROUTES } from '../constants'
import { VehicleStatus } from '../api-client/enums'
import { useAuth } from '../contexts/auth'

export default function useMyVehicles(vin) {
  const [URL, setURL] = useState(null)
  const [{ isAuthenticated, userDetails }] = useAuth()

  const { data, isSuccess: vehiclesDataSuccess } = useQuery({
    queryKey: getMyVehiclesKey,
    queryFn: getMyVehicles,
    refetchInterval: 300_000,
    enabled: isAuthenticated,
  })

  useEffect(() => {
    setURL('')
    if (vin && vehiclesDataSuccess && data?.vehicles?.length > 0) {
      const vehicle =
        data?.vehicles?.filter((v) => v.vin === vin)?.length > 0
          ? data?.vehicles?.filter((v) => v.vin === vin)[0]
          : null
      if (vehicle) {
        if (
          (vehicle.status === VehicleStatus.SubmittedForAuctionReview && !userDetails.isDealer) ||
          (vehicle.status === VehicleStatus.SubmittedForBuyNowReview && !userDetails.isDealer) ||
          (vehicle.status === VehicleStatus.Stopped && !userDetails.isDealer) ||
          vehicle.status === VehicleStatus.SubmittedForCashOffer ||
          vehicle.status === VehicleStatus.SentForCashOffer ||
          vehicle.status === VehicleStatus.ApprovedForBuyNow ||
          vehicle.status === VehicleStatus.CompletedFromBuyNow ||
          vehicle.status === VehicleStatus.ApprovedForAuction ||
          vehicle.status === VehicleStatus.OnLiveAuction ||
          vehicle.status === VehicleStatus.CompletedFromAuction ||
          vehicle.status === VehicleStatus.CompletedFromCashOffer
        ) {
          setURL(`${ROUTES.VehicleLogs}/${vehicle.id}`)
        } else if (
          vehicle.status === VehicleStatus.Draft ||
          vehicle.status === VehicleStatus.RejectedForBuyNow ||
          vehicle.status === VehicleStatus.RejectedForAuction ||
          vehicle.status === VehicleStatus.CanceledByAdminForCashOffer ||
          vehicle.status === VehicleStatus.CanceledBySellerForCashOffer ||
          vehicle.status === VehicleStatus.CanceledByExpirationForCashOffer ||
          vehicle.status === VehicleStatus.DeclinedByAdminForCashOffer ||
          vehicle.status === VehicleStatus.DeclinedBySellerForCashOffer ||
          (vehicle.status === VehicleStatus.Stopped && userDetails.isDealer) ||
          (vehicle.status === VehicleStatus.SubmittedForAuctionReview && userDetails.isDealer) ||
          (vehicle.status === VehicleStatus.SubmittedForBuyNowReview && userDetails.isDealer)
        ) {
          setURL(`${ROUTES.VehicleDetails}/${vehicle.id}`)
        }
      }
    }
  }, [data?.vehicles, vehiclesDataSuccess, vin, userDetails.isDealer])

  return URL
}
